import React from "react";
// import CompA from "./ContextApi";
// import Effect from "./Effect";
// import Covid from "./Covid";
import Movies from "./Movie";


function App() {
  return (
    <>
      <Movies />
      {/* <Covid /> */}
      {/* <CompA />
      <Effect/> */}
    </>
  );
}

export default App;
